export default "__VITE_ASSET__hrlZgEFG__"